<script>
import { mapGetters } from 'vuex';
import FilterChip from './FilterChip.vue';

export default {
  name: 'ReportsFiltersInboxes',
  components: { FilterChip },
  emits: ['inboxFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      options: 'inboxes/getInboxes',
    }),
  },
  mounted() {
    this.$store.dispatch('inboxes/get');
  },
  methods: {
    handleInput() {
      this.$emit('inboxFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <FilterChip
    v-model="selectedOption"
    :options="options"
    :placeholder="$t('INBOX_REPORTS.FILTER_DROPDOWN_LABEL')"
    icon="i-lucide-inbox"
    @update:model-value="handleInput"
  />
</template>
